export const Directions = {
    Up: 'Up',
    Right: 'Right',
    Down: 'Down',
    Left: 'Left',
};
